const CHANGE_PATIENT_NUMBER = "patient/CHANGE_PATIENT_NUMBER";
const SELECTED_PATIENT = "patient/SELECTED_PATIENT";
const SELECTED_PATIENT_DETAIL = "patient/SELECTED_PATIENT_DETAIL";
const TOGGLE_MODAL_CONFIRM = "patient/TOGGLE_MODAL_CONFIRM";
const RESET_MODAL_CONFIRM = "patient/RESET_MODAL_CONFIRM";
const CHECK_CONFIRM = "patient/CHECK_CONFIRM";
const RESET_CONFIRM_CHECK = "patient/RESET_CONFIRM_CHECK";
const CLEAR_STATE = "patient/CLEAR_STATE";
const RESET_DATA = "patient/RESET_DATA";

const GET_PATIENT_BY_USERID_REQUEST = "patient/GET_PATIENT_BY_USERID_REQUEST";
const GET_PATIENT_BY_USERID_SUCCESS = "patient/GET_PATIENT_BY_USERID_SUCCESS";
const GET_PATIENT_BY_USERID_FAILURE = "patient/GET_PATIENT_BY_USERID_FAILURE";

const GET_PATIENT_BY_MSBN_REQUEST = "patient/GET_PATIENT_BY_MSBN_REQUEST";
const GET_PATIENT_BY_MSBN_SUCCESS = "patient/GET_PATIENT_BY_MSBN_SUCCESS";
const GET_PATIENT_BY_MSBN_FAILURE = "patient/GET_PATIENT_BY_MSBN_FAILURE";
const RESET_FORM_GET_PATIENT_BY_MSBN = "patient/RESET_FORM_GET_PATIENT_BY_MSBN";

const INSERT_PATIENT_REQUEST = "patient/INSERT_PATIENT_REQUEST";
const INSERT_PATIENT_SUCCESS = "patient/INSERT_PATIENT_SUCCESS";
const INSERT_PATIENT_FAILURE = "patient/INSERT_PATIENT_FAILURE";

const DELETE_PATIENT_REQUEST = "patient/DELETE_PATIENT_REQUEST";
const DELETE_PATIENT_SUCCESS = "patient/DELETE_PATIENT_SUCCESS";
const DELETE_PATIENT_FAILURE = "patient/DELETE_PATIENT_FAILURE";

const SEARCH_PATIENT_BY_INFO_REQUEST = "patient/SEARCH_PATIENT_BY_INFO_REQUEST";
const SEARCH_PATIENT_BY_INFO_REQUEST_SUCCESS =
  "patient/SEARCH_PATIENT_BY_INFO_REQUEST_SUCCESS";
const SEARCH_PATIENT_BY_INFO_REQUEST_FAILURE =
  "patient/SEARCH_PATIENT_BY_INFO_REQUEST_FAILURE";

const SHOW_LOADING = "patient/SHOW_LOADING";
const HIDE_LOADING = "patient/HIDE_LOADING";

// const GET_CLS_SEARCH_HISTORY_REQUEST = "patient/GET_CLS_SEARCH_HISTORY_REQUEST";
// const GET_CLS_SEARCH_HISTORY_SUCCESS = "patient/GET_CLS_SEARCH_HISTORY_SUCCESS";
// const GET_CLS_SEARCH_HISTORY_FAILURE = "patient/GET_CLS_SEARCH_HISTORY_FAILURE";

const UMC_CHOOSE_PATIENT_LIST_REQUEST =
  "patient/@@UMC_CHOOSE_PATIENT_LIST_REQUEST";
const UMC_CHOOSE_PATIENT_LIST_REQUEST_SUCCESS =
  "patient/@@UMC_CHOOSE_PATIENT_LIST_REQUEST_SUCCESS";
const UMC_CHOOSE_PATIENT_LIST_REQUEST_FAIL =
  "patient/@@UMC_CHOOSE_PATIENT_LIST_REQUEST_FAIL";

// choose patient

const TOGGLE_MODAL_CHOOSE_PATIENT = "patient/TOGGLE_MODAL_CHOOSE_PATIENT";
const RESET_MODAL_CHOOSE_PATIENT = "patient/RESET_MODAL_CHOOSE_PATIENT";
const SELECTED_PATIENT_AFTER_CREATE = "patient/SELECTED_PATIENT_AFTER_CREATE";
const UPDATE_SELECTED_PATIENT = "patient/UPDATE_SELECTED_PATIENT";
const SHOW_ALERT_INFO_CHOOSE_PATIENT = "patient/SHOW_ALERT_INFO_CHOOSE_PATIENT";
const HIDE_ALERT_INFO_CHOOSE_PATIENT = "patient/HIDE_ALERT_INFO_CHOOSE_PATIENT";
const RESET_REDIRECT_TO_CHECK_PHONE = "patient/RESET_REDIRECT_TO_CHECK_PHONE";

// 06-02-2020 - Gom chung Patient
const GET_MEDPRO_PATIENT_LIST = "patient/GET_MEDPRO_PATIENT_LIST";
const GET_MEDPRO_PATIENT_LIST_SUCCESS =
  "patient/GET_MEDPRO_PATIENT_LIST_SUCCESS";
const GET_MEDPRO_PATIENT_LIST_FAIL = "patient/GET_MEDPRO_PATIENT_LIST_FAIL";

const GET_MEDPRO_PATIENT_SUGGESTION_LIST =
  "patient/GET_MEDPRO_PATIENT_SUGGESTION_LIST";
const GET_MEDPRO_PATIENT_SUGGESTION_LIST_SUCCESS =
  "patient/GET_MEDPRO_PATIENT_SUGGESTION_LIST_SUCCESS";
const GET_MEDPRO_PATIENT_SUGGESTION_LIST_FAIL =
  "patient/GET_MEDPRO_PATIENT_SUGGESTION_LIST_FAIL";

// Đang dùng
const SELECT_PATIENT_REEXAM = "patient/SELECT_PATIENT_REEXAM";
const SELECT_PATIENT_REEXAM_SUCCESS = "patient/SELECT_PATIENT_REEXAM_SUCCESS";

const SELECT_PATIENT_FROM_LIST = "patient/SELECT_PATIENT_FROM_LIST";
const SELECT_PATIENT_FROM_DATA = "patient/SELECT_PATIENT_FROM_DATA";

const CHECK_INSURANCE = "patient/CHECK_INSURANCE";
const CHECK_INSURANCE_SUCCESS = "patient/CHECK_INSURANCE_SUCCESS";
const CHECK_INSURANCE_FAIL = "patient/CHECK_INSURANCE_FAIL";

const VERIFY_PHONE_PATIENT = "patient/VERIFY_PHONE_PATIENT";
const VERIFY_PHONE_PATIENT_SUCCESS = "patient/VERIFY_PHONE_PATIENT_SUCCESS";
const VERIFY_PHONE_PATIENT_FAILURE = "patient/VERIFY_PHONE_PATIENT_FAILURE";

const VERIRY_PATIENT_WITHOUT_PHONE = "patient/VERIRY_PATIENT_WITHOUT_PHONE";

const VERIFY_INFO_PATIENT = "patient/VERIFY_INFO_PATIENT";
const VERIFY_INFO_PATIENT_SUCCESS = "patient/VERIFY_INFO_PATIENT_SUCCESS";
const VERIFY_INFO_PATIENT_FAILURE = "patient/VERIFY_INFO_PATIENT_FAILURE";

const SAVE_FIELD_FORM_SEARH_PATIENT_BY_INFO =
  "patient/SAVE_FIELD_FORM_SEARH_PATIENT_BY_INFO";
const SAVE_FIELD_FORM_CHECK_INSURANCE =
  "patient/SAVE_FIELD_FORM_CHECK_INSURANCE";
const RESET_FORM_CHECK_INSURANCE = "patient/RESET_FORM_CHECK_INSURANCE";
const UPDATE_FORM_CHECK_INSURANCE = "patient/UPDATE_FORM_CHECK_INSURANCE";
const SCAN_QR_CODE_INSURANCE_SUCCESS = "patient/SCAN_QR_CODE_INSURANCE_SUCCESS";
const RESET_STATUS_SCAN_QR_CODE_INSURANCE =
  "patient/RESET_STATUS_SCAN_QR_CODE_INSURANCE";

const CHECK_INSURANCE_OF_PATIENT = "patient/CHECK_INSURANCE_OF_PATIENT";
const CHECK_INSURANCE_OF_PATIENT_FAILED =
  "patient/CHECK_INSURANCE_OF_PATIENT_FAILED";
const RESET_ERROR_CHECK_INSURANCE = "patient/RESET_ERROR_CHECK_INSURANCE";

export default {
  // ReExam
  SELECT_PATIENT_REEXAM,
  SELECT_PATIENT_REEXAM_SUCCESS,

  CHANGE_PATIENT_NUMBER,
  SELECTED_PATIENT,
  SELECTED_PATIENT_DETAIL,
  TOGGLE_MODAL_CONFIRM,
  RESET_MODAL_CONFIRM,
  CHECK_CONFIRM,
  RESET_CONFIRM_CHECK,
  CLEAR_STATE,
  RESET_DATA,

  GET_PATIENT_BY_USERID_REQUEST,
  GET_PATIENT_BY_USERID_SUCCESS,
  GET_PATIENT_BY_USERID_FAILURE,

  GET_PATIENT_BY_MSBN_REQUEST,
  GET_PATIENT_BY_MSBN_SUCCESS,
  GET_PATIENT_BY_MSBN_FAILURE,
  RESET_FORM_GET_PATIENT_BY_MSBN,

  INSERT_PATIENT_REQUEST,
  INSERT_PATIENT_SUCCESS,
  INSERT_PATIENT_FAILURE,

  DELETE_PATIENT_REQUEST,
  DELETE_PATIENT_SUCCESS,
  DELETE_PATIENT_FAILURE,

  SEARCH_PATIENT_BY_INFO_REQUEST,
  SEARCH_PATIENT_BY_INFO_REQUEST_SUCCESS,
  SEARCH_PATIENT_BY_INFO_REQUEST_FAILURE,

  SHOW_LOADING,
  HIDE_LOADING,

  // GET_CLS_SEARCH_HISTORY_REQUEST,
  // GET_CLS_SEARCH_HISTORY_SUCCESS,
  // GET_CLS_SEARCH_HISTORY_FAILURE,

  // choose patient
  UMC_CHOOSE_PATIENT_LIST_REQUEST,
  UMC_CHOOSE_PATIENT_LIST_REQUEST_SUCCESS,
  UMC_CHOOSE_PATIENT_LIST_REQUEST_FAIL,

  SELECT_PATIENT_FROM_LIST,
  SELECT_PATIENT_FROM_DATA,

  TOGGLE_MODAL_CHOOSE_PATIENT,
  RESET_MODAL_CHOOSE_PATIENT,
  SELECTED_PATIENT_AFTER_CREATE,
  UPDATE_SELECTED_PATIENT,
  SHOW_ALERT_INFO_CHOOSE_PATIENT,
  HIDE_ALERT_INFO_CHOOSE_PATIENT,

  RESET_REDIRECT_TO_CHECK_PHONE,

  GET_MEDPRO_PATIENT_LIST,
  GET_MEDPRO_PATIENT_LIST_SUCCESS,
  GET_MEDPRO_PATIENT_LIST_FAIL,

  GET_MEDPRO_PATIENT_SUGGESTION_LIST,
  GET_MEDPRO_PATIENT_SUGGESTION_LIST_SUCCESS,
  GET_MEDPRO_PATIENT_SUGGESTION_LIST_FAIL,

  // Đang dùng
  CHECK_INSURANCE,
  CHECK_INSURANCE_SUCCESS,
  CHECK_INSURANCE_FAIL,

  VERIFY_PHONE_PATIENT,
  VERIFY_PHONE_PATIENT_SUCCESS,
  VERIFY_PHONE_PATIENT_FAILURE,

  VERIFY_INFO_PATIENT,
  VERIFY_INFO_PATIENT_SUCCESS,
  VERIFY_INFO_PATIENT_FAILURE,

  VERIRY_PATIENT_WITHOUT_PHONE,

  SAVE_FIELD_FORM_SEARH_PATIENT_BY_INFO,
  SAVE_FIELD_FORM_CHECK_INSURANCE,
  UPDATE_FORM_CHECK_INSURANCE,
  RESET_FORM_CHECK_INSURANCE,

  SCAN_QR_CODE_INSURANCE_SUCCESS,
  RESET_STATUS_SCAN_QR_CODE_INSURANCE,

  CHECK_INSURANCE_OF_PATIENT,
  CHECK_INSURANCE_OF_PATIENT_FAILED,
  RESET_ERROR_CHECK_INSURANCE
};
